import React from "react";
import Table from "../Table";

const title = "User Details";
const columns = [
  {
    name: "Mem ID",
    selector: "id",
    sortable: false
  },
  {
    name: "Login Name",
    selector: "loginName",
    sortable: false,
    cell: row => {
      return <span title={row.loginName}>{row.loginName}</span>;
    }
  },
  {
    name: "First Name",
    selector: "name.first",
    sortable: false
  },
  {
    name: "Last Name",
    selector: "name.last",
    sortable: false
  },
  {
    name: "Email",
    selector: "email",
    sortable: false
  }
];

function UserTable(props) {
  return (
    <Table
      title={title}
      columns={columns}
      data={props.data}
      pagination={false}
    />
  );
}

export default UserTable;
